
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandX as ObiOwnShipNoCommandXElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-x.js';
 
 
 

 
 export const ObiOwnShipNoCommandX = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-x',
   elementClass: ObiOwnShipNoCommandXElement,
   events: {
     
   }
  });
 
 